export enum AlertColours {
    'high' = '#FF5252',
    'medium' = '#FF9B3E',
    'low' = '#84FF70'
} 